<div
  #thumbnailScroller
  [scrollTop]="scrollTopSubject | async"
  class="thumbnail-scroller"
  
>

  <div *ngFor="let pdfDocument of pdfDocumentInputsSubject | async" class="full-width">

      <div class="title-div border-gray-top border-gray-bottom padding-none full-width background-white">
        <mat-card-header class="padding-small">
          <mat-card-subtitle class="wrap-break-word">{{pdfDocument.shortDisplay}}</mat-card-subtitle>
        </mat-card-header>
      </div>

      <ss-pdf-thumbnail-viewport class="display-block padding-small-inline"  [pdfDocument]="pdfDocument"></ss-pdf-thumbnail-viewport>
  </div>

  
</div>